import initScrollReveal from "./scripts/scrollReveal";
import initTiltEffect from "./scripts/tiltAnimation";
import { targetElements, defaultProps } from "./data/scrollRevealConfig";
import { applyResultStyles, checkEmail, emptyAndPlaceholder, sendResumeByEmail } from "./scripts/email";

initScrollReveal(targetElements, defaultProps);
initTiltEffect();

document.addEventListener('DOMContentLoaded', () => {
    const emailInput = document.getElementById('emailInput');
    const sendEmailButton = document.getElementById('sendEmailButton');

    sendEmailButton.addEventListener('click', (e) => {
        e.preventDefault();
        const email = emailInput.value;

        if (email && checkEmail(email)) {
            emptyAndPlaceholder(emailInput, 'Please wait...');
            sendResumeByEmail(email)
                .then(() => {
                    applyResultStyles(true, emailInput, 'Email sent!');
                })
                .catch(() => {
                    applyResultStyles(false, emailInput, 'Failed to send email, try again later!');
                });
        } else {
            applyResultStyles(false, emailInput, 'Invalid email!');
        }
    });
});
